
(function ($, window) {
    //Modifications to the carousel transition
    $.fn.cycle.transitions.carousel.prepareDimensions = function (opts) {
        var dim, offset, pagerCutoffIndex, tmp, j;
        var vert = opts.carouselVertical;
        var visCount = opts.carouselVisible || opts.slides.length;

        if (opts.carouselFluid && opts.carouselVisible) {
            if (!opts._carouselResizeThrottle) {
                // fluid container AND fluid slides; slides need to be resized to fit container
                this.fluidSlides(opts);
            }
        } else if (opts.carouselVisible && opts.carouselSlideDimension) {
            dim = visCount * opts.carouselSlideDimension;
            opts.container[ vert ? 'height' : 'width' ](dim);
        } else if (opts.carouselVisible) {
            dim = visCount * $(opts.slides[0])[vert ? 'outerHeight' : 'outerWidth'](true);
            opts.container[ vert ? 'height' : 'width' ](dim);
        }

        offset = (opts.carouselOffset || 0);
        if (!opts.carouselOffset) {
            if (opts.allowWrap !== false) {
                if (opts.carouselSlideDimension) {
                    offset -= ((opts.slideCount + opts.currSlide) * opts.carouselSlideDimension);
                } else {
                    // calculate offset based on actual slide dimensions
                    tmp = opts._carouselWrap.children();
                    for (j = 0; j < (opts.slideCount + opts.currSlide); j++) {
                        offset -= $(tmp[j])[vert ? 'outerHeight' : 'outerWidth'](true);
                    }
                }
            }
        }
        opts._carouselWrap.css(vert ? 'top' : 'left', offset);
    };
    
    var Associates = function($wrapper) {
        var $scroller = $wrapper.find('.ASSOCIATES_SCROLL'), 
            wide = $(window).width() > 1024, laptop = wide && $scroller.find('.Associate').height() < 600,
            slides = [], offset = 0;
            //Default cycle options
            var cycleOpts = {
                wide: {
                    fx: 'carousel',
                    paused: true,
                    log: false,
                    speed: 200,
                    easing: "linear",
                    slides: ".Associate",
                    throttleSpeed: true,
                    carouselOffset: offset,
                    swipe: true
                },
                small: {
                    fx: 'carousel',
                    paused: true,
                    log: false,
                    speed: 500,
                    easing: "easeOutQuart",
                    slides: ".Associate",
                    throttleSpeed: true,
                    carouselVisible: 1,
                    carouselFluid: true,
                    swipe: true
                }
            };
    
            var deactivate = function () {
                $wrapper.removeClass('associates-activated');
                $wrapper.find('.Associate').removeClass('associate-active');
            };
            
            this.deactivate = deactivate;
            
            var isInViewport = function($item) {
                var offset = $item.offset();
                return (offset.left > -150 || offset.left +$item.width() > -150) && offset.left < $(window).width()+150;
            };
    
            //Prepare navigation
            $wrapper.addClass('associates-js');
            $wrapper.append('<button class="icon-anchor-circle-right"></button>');
            $wrapper.append('<button class="icon-anchor-circle-left"></button>');
            
            function fillAssociates() {
                $wrapper.find('.associate-img-not-loaded > a').each(function() {
                    var $holder = $(this);
                    $holder.width($holder.height()*$holder.data('imgWidth')/$holder.data('imgHeight'));                
                });
            }
            
            function loadAssociate($item) {
                
                if (!$item.hasClass('associate-img-not-loaded')) {
                    return;
                }
                
                $item.removeClass('associate-img-not-loaded');
                $item.addClass('associate-img-loading');
                //generate img tag
                var $img = $('<img />'), $imgHolder = $item.find('[data-img-src]');
                $img.attr({'alt': $imgHolder.data('imgAlt'), 'data-tooltip': ''});
                $img.data('tooltipTitle', $imgHolder.data('imgTitle'));
                $img.data('tooltipEnabled', wide);
                $img.attr('data-tooltip-title', $imgHolder.data('imgTitle'));
                $img.attr('title', '');
                $img.addClass('associate-img-hide');
                $imgHolder.append('<span class="associate-loader"><span class="associate-loader-dot"></span><span class="associate-loader-dot"></span><span class="associate-loader-dot"></span></span>');
                //listen for loading 
                $img.on('load', function() {
                    //animate appearance
                    $imgHolder.css('width', '');
                    $img.removeClass('associate-img-hide');
                    $item.removeClass('associate-img-loading');
                    //Copy img tag to other instances
                    setTimeout(function() {
                        $wrapper.find('.'+$item.attr('id')).removeClass('associate-img-not-loaded');
                        $wrapper.find('.'+$item.attr('id')).find('[data-img-src]').each(function() {
                            $(this).append($img.clone());
                            $(this).css('width', '');
                            $(this).removeAttr('data-img-src');
                        });
                    }, 400);
                });
                $imgHolder.append($img);
                $img.attr('src', $imgHolder.data('imgSrc'));
                //remove data properties
                $item.removeAttr('data-img-src');
            }   
            
            function loadAssociates() {
                $scroller.find('.Associate.associate-img-not-loaded').each(function() {
                    if (isInViewport($(this))) {
                        loadAssociate($(this));
                    }
                });
            }
            
            //Generate placeholders for images
            var $associates = $scroller.find('.Associate').addClass('associate-img-not-loaded');
            fillAssociates();
            
            //Count slides
            $associates.each(function () {
                slides.push($(this).attr('id'));
                offset -= $(this).outerWidth(true);
            });
            
            //Init cycle
            $scroller.cycle(wide ? cycleOpts.wide : cycleOpts.small);
            $scroller.on('cycle-update-view', function() {
                loadAssociates();
            });
            //Enable tooltip if wide screen
            //$wrapper.find('*[data-tooltip]').data('tooltipEnabled', wide);
            $wrapper.addClass('associates-' + (wide ? 'wide' : 'one'));
            
            
            $(window).off('.teamscroll');
            $(window).on('resize.teamscroll', function () {
                function switchCycle() {
                    $wrapper.css('minHeight', $scroller.height());
                    $scroller.cycle('destroy');
                    if (wide) {
                        offset = 0;
                        $scroller.find('.Associate').each(function () {
                            offset -= $(this).outerWidth(true);
                        });
                        cycleOpts.wide.carouselOffset = offset;
                    }
                    $scroller.cycle(wide ? cycleOpts.wide : cycleOpts.small);
                }
                
                fillAssociates();
                loadAssociates();

                if (laptop && wide && $scroller.find('.Associate').height() > 600) {
                    laptop = false;
                    deactivate();
                    switchCycle();
                } else if (!laptop && wide && $scroller.find('.Associate').height() < 600) {
                    laptop = true;
                    deactivate();
                    switchCycle();
                }

                if (wide && $(this).width() <= 1024) {
                    wide = false;
                    $wrapper.addClass('associates-one');
                    $wrapper.removeClass('associates-wide');
                    deactivate();
                    switchCycle();
                    $wrapper.find('*[data-tooltip]').data('tooltipEnabled', false);
                } else if (!wide && $(this).width() > 1024) {
                    wide = true;
                    $wrapper.removeClass('associates-one');
                    $wrapper.addClass('associates-wide');
                    switchCycle();
                    $wrapper.find('*[data-tooltip]').data('tooltipEnabled', true);
                }
            });

            $wrapper.find('.icon-anchor-circle-right').on('click', function () {
                if ($wrapper.hasClass('associates-activated')) {
                    var left = parseFloat($wrapper.find('.cycle-carousel-wrap').css('left')), windowWidth = $(window).width();
                    $wrapper.find('.associate-active').each(function () {
                        var position = $(this).position();
                        if (position.left > Math.abs(left) && position.left < Math.abs(left) + windowWidth) {
                            $(this).next().find('.post-thumbnail').trigger('click');
                            return false;
                        }
                    });
                } else {
                    $scroller.cycle('next');
                }
            });
            $wrapper.find('.icon-anchor-circle-left').on('click', function () {
                if ($wrapper.hasClass('associates-activated')) {
                    var left = parseFloat($wrapper.find('.cycle-carousel-wrap').css('left')), windowWidth = $(window).width();
                    $wrapper.find('.associate-active').each(function () {
                        var position = $(this).position();
                        if (position.left > Math.abs(left) && position.left < Math.abs(left) + windowWidth) {
                            $(this).prev().find('.post-thumbnail').trigger('click');
                            return false;
                        }
                    });
                } else {
                    $scroller.cycle('prev');
                }
            });

            $wrapper.on('click', '.Associate .BackLink', function (e) {
                e.preventDefault();
                deactivate();
            });
            $wrapper.on('click', '.Associate .post-thumbnail', function (e) {
                e.preventDefault();
                if (!wide) {
                    $(this).next('.associate-content').find('.Button').trigger('click');
                    return;
                }
                var $associate = $(this).parent();
                var distance = $(window).width() > 1600 ? 2 : 1;
                if (!$associate.hasClass('associate-active')) {
                    var index = slides.indexOf($associate.attr('id')) - distance, startingIndex = $scroller.data('cycle.opts').currSlide, direction, steps = 0;
                    if (index < 0) {
                        index = slides.length + index;
                    }
                    steps = Math.min(Math.abs(startingIndex - index), slides.length - index + startingIndex, slides.length - startingIndex + index);//slides.length - startingIndex+index;
                    if (Math.abs(startingIndex - index) === steps) {
                        direction = startingIndex < index ? 'next' : 'prev';
                    } else {
                        direction = startingIndex > index ? 'next' : 'prev';
                    }

                    //Deactivate active associate
                    $wrapper.find('.Associate').removeClass('associate-active');

                    for (var i = 0; i < steps; i++) {
                        setTimeout(function () {
                            $scroller.cycle(direction);
                        }, 200 * i);
                    }
                    setTimeout(function () {
                        //Activate new associate
                        $wrapper.addClass('associates-activated');
                        //$scroller.find('[id="'+$associate.attr('id')+'"]').addClass('associate-active');
                        $scroller.find('[id="' + $associate.attr('id') + '"]:visible').addClass('associate-active');
                    }, 200 * steps);

                }

            });
            $('.PAGE').on('click', function (e) {
                if ($(e.target).hasClass('ASSOCIATES') || $(e.target).parents('.ASSOCIATES').length) {
                    return;
                }
                deactivate();
            });
    };

    $.fn.associates = function () {
        $(this).each(function () {
            $(this).data('associatesInstance', new Associates($(this)));
        });

        return this;
    }
    ;


})(jQuery, window);